import { gsap } from "gsap";

class ReadMore {
  constructor(el) {
    this.dom = {el: el, acd: {}};
    this.dom.container = this.dom.el.querySelector('[data-js="readmore-container"]');
    this.dom.inner = this.dom.el.querySelector('[data-js="readmore-inner"]');
    this.dom.trigger = this.dom.el.querySelector('[data-js="readmore-trigger"]');
    this.dom.label = this.dom.el.querySelector('[data-js="readmore-label"]');
    
    this.openCloseLabel = this.dom.label.dataset.label.split(':');
    this.label = {
      open: this.openCloseLabel[0],
      close: this.openCloseLabel[1]
    }

    this.rowVal = this.dom.el.dataset.row.split(':');
    this.row = {
      sp: this.rowVal[0],
      pc: this.rowVal[1]
    }
    this.initH = this.getStyle(this.dom.inner, 'height')
    this.lh = this.getStyle(this.dom.container.querySelector('p'), 'line-height')

    this.closeH = this.getRow() * parseInt(this.lh);

    this.isOpen = false;
    this.toggle = this.toggle.bind(this);
    this.resize = this.resize.bind(this);
    
    this.init();
  }
  
  init() {
    this.dom.container.style.height = `${this.closeH}px`;

    this.dom.trigger.addEventListener('click', this.toggle);
    window.addEventListener('resize', this.resize)
  }

  toggle(e) {
    console.log('fg')
    if (!this.isOpen) {
      e.currentTarget.classList.add('isOpen');
    } else {
      e.currentTarget.classList.remove('isOpen');
    }
    gsap.to(this.dom.container, {
      height: (!this.isOpen) ? this.initH : this.closeH,
      duration: .3,
      ease: 'circ.inOut',
      onComplete: () => {
        this.isOpen = !this.isOpen
      }
    })
    this.dom.label.textContent = (!this.isOpen) ? this.label.close : this.label.open;
  }

  resize() {
    this.initH = this.getStyle(this.dom.inner, 'height')
    this.lh = this.getStyle(this.dom.container.querySelector('p'), 'line-height')
    this.closeH = this.getRow() * parseInt(this.lh);
    this.dom.container.style.height = `${this.closeH}px`;
  }

  getRow() {
    return (window.innerWidth < 768) ? this.row.sp : this.row.pc
  }

  getStyle(el, prop) {
    const style = window.getComputedStyle(el);
    return style.getPropertyValue(prop);
  }
}

export default ReadMore